'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _userCertificates = require('./user-certificates.html');

var _userCertificates2 = _interopRequireDefault(_userCertificates);

var _userCertificates3 = require('./user-certificates.controller');

var _userCertificates4 = _interopRequireDefault(_userCertificates3);

require('./user-certificates.styl');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var userCertificatesComponent = {
  restrict: 'E',
  bindings: {
    certificates: '<'
  },
  template: _userCertificates2.default,
  controller: _userCertificates4.default,
  controllerAs: 'vm'
};

exports.default = userCertificatesComponent;


/** WEBPACK FOOTER **
 ** ./client/app/common/Components/user-certificates/user-certificates.component.js
 **/